import { defineMessages } from 'react-intl';
import * as Actions from '../../../create-label-content/create-label-content.actions';

const messages = defineMessages({
  createAndPrintLabel: {
    defaultMessage: 'Schedule + Print Label',
    id: 'awt8kR',
    description: 'CSW primary button label - Schedule + Print Label',
  },
});

export const createAndPrintLabel = {
  id: 'createAndPrintLabel',
  translation: messages.createAndPrintLabel,

  getActionFromFulfillmentPlanId: (fulfillmentPlanId, labelMetadata) => {
    return Actions.createLabel({
      fulfillmentPlanId,
      doNotPrint: false,
      labelMetadata,
    });
  },
};
